import { LoadStatus } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { AuthApi } from 'api';
import { makeObservable, observable, runInAction } from 'mobx';
import { LoginResult, PortalAuthStore } from './portal-auth.store';

@injectable()
export class GoogleAuthStore {
    @observable submitStatus = LoadStatus.None;
    @observable submitResult?: LoginResult;
    @observable iframeUrl: string | null = null;

    constructor(
        @inject(PortalAuthStore) private authStore: PortalAuthStore,
        @inject(AuthApi) private authApi: AuthApi
    ) {
        makeObservable(this);
    }

    submit = async (idToken: string) => {
        runInAction(() => (this.submitStatus = LoadStatus.Loading));

        const loginError = await this.authStore.loginWithGoogle(idToken);

        runInAction(() => {
            this.submitStatus = !loginError ? LoadStatus.Ok : LoadStatus.Error;
            this.submitResult = loginError;
        });
    };

    fetchIframeUrl = async () => {
        const url = await this.authApi.client.getGoogleOneTapIframeUrl();
        runInAction(() => (this.iframeUrl = url));
    };
}
